import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useScrollReveal } from '../../../useScrollReveal';
import './CompactImageCard.css';

const CompactImageCard = ({ image, video, caption, title, overlay, tilt }) => {
    const { ref, style } = useScrollReveal('fadeUp');

    return (
        <div
            className={`CompactImageCard ${tilt ? 'CompactImageCard--tilt' : ''}`}
            ref={ref}
            style={style}
        >
            <div className="CompactImageCard-imageWrap">
                {video ? (
                    <video autoPlay muted loop playsInline className="CompactImageCard-img">
                        <source src={video} type="video/mp4" />
                    </video>
                ) : (
                    <Zoom>
                        <img
                            src={image}
                            alt={title || caption || ''}
                            className="CompactImageCard-img"
                        />
                    </Zoom>
                )}
                {overlay && (
                    <div className="CompactImageCard-overlay">
                        <span>{overlay}</span>
                    </div>
                )}
            </div>
            {(title || caption) && (
                <div className="CompactImageCard-info">
                    {title && <h3 className="CompactImageCard-title">{title}</h3>}
                    {caption && <p className="CompactImageCard-caption">{caption}</p>}
                </div>
            )}
        </div>
    );
};

export default CompactImageCard;
